/* eslint-disable max-lines */
/* eslint-disable prefer-object-spread */
import axios from 'axios';
import SparkMD5 from 'spark-md5';
import CryptoJS from 'crypto-js';
import { SALES } from '../constants';
import { commonTernary } from './commercialService';
import { wcApiUrl } from '../WebComponents/commonComponents/customUtils';
import { getRuntimePlatform, isCordovaFn } from '../components/commonCode';

export const uploadDocument = async (
  fileFormat,
  fileName,
  fileType,
  formData,
  accessToken,
  setStatementUploadProgress,
  setStatementLinearProgress,
  initiateUiResponse,
  options = {}
) => {
  const { commonDocUpload = false, isWCFlow = false, env = '' } = options;
  let response = null;
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        `${
          wcApiUrl(env).REACT_APP_DOCUMENT_UPLOAD_URL
        }?format=${fileFormat}&name=${fileName}&type=${fileType}`,
        `${initiateUiResponse.REACT_APP_DOCUMENT_UPLOAD_URL}?format=${fileFormat}&name=${fileName}&type=${fileType}`
      ),
      formData,
      {
        headers: {
          appid: 'sales',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setStatementUploadProgress((prev) =>
            commonDocUpload ? { ...prev, [fileType]: percentCompleted } : percentCompleted
          );

          if (percentCompleted === 100) {
            setStatementLinearProgress((prev) =>
              commonDocUpload ? { ...prev, [fileType]: true } : true
            );
          }
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};

export const uploadDocumentXL = async (
  fileFormat,
  fileName,
  fileType,
  fileSize,
  fileMd5Base64,
  accessToken,
  setStatementUploadProgress,
  setStatementLinearProgress,
  initiateUiResponse,
  options = {}
) => {
  const { commonDocUpload = false, isWCFlow = false, env = '' } = options;
  let response = null;
  const requestBody = {
    format: fileFormat,
    name: fileName,
    type: fileType,
    size: fileSize,
    contentMD5: fileMd5Base64,
  };
  try {
    response = await axios.post(
      commonTernary(
        isWCFlow,
        `${wcApiUrl(env).REACT_APP_DOCUMENT_UPLOAD_XL_URL}`,
        `${initiateUiResponse.REACT_APP_DOCUMENT_UPLOAD_XL_URL}`
      ),
      requestBody,
      {
        headers: {
          appid: 'sales',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },

        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setStatementUploadProgress((prev) =>
            commonDocUpload ? { ...prev, [fileType]: percentCompleted } : percentCompleted
          );

          if (percentCompleted === 100) {
            setStatementLinearProgress((prev) =>
              commonDocUpload ? { ...prev, [fileType]: true } : true
            );
          }
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};

// export const uploadDocumentByPreSignedURL = async (
//   preSignedUrl,
//   file,
//   fileMd5Base64,
//   setStatementUploadProgress,
//   setStatementLinearProgress,
//   fileType,
//   options = {}
// ) => {
//   const { commonDocUpload = false } = options;
//   let response = null;
//   try {
//     response = await axios.put(preSignedUrl, file, {
//       headers: {
//         appid: 'sales',
//         'Content-Type': 'multipart/form-data',
//         'Content-MD5': fileMd5Base64,
//       },
//       onUploadProgress: (progressEvent) => {
//         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//         setStatementUploadProgress((prev) =>
//           commonDocUpload ? { ...prev, [fileType]: percentCompleted } : percentCompleted
//         );

//         if (percentCompleted === 100) {
//           setStatementLinearProgress((prev) =>
//             commonDocUpload ? { ...prev, [fileType]: true } : true
//           );
//         }
//       },
//     });
//   } catch (e) {
//     return response;
//   }
//   return response;
// };
export const uploadDocumentByPreSignedURL = async (
  preSignedUrl,
  file,
  fileMd5Base64,
  setStatementUploadProgress,
  setStatementLinearProgress,
  fileType,
  options = {}
) => {
  const { commonDocUpload = false } = options;
  let response = null;

  try {
    // CRITICAL FIX for iOS Cordova:
    //
    // The original code sends Content-Type: multipart/form-data for a pre-signed
    // S3 PUT. S3 pre-signed PUTs expect a raw binary body — multipart/form-data
    // causes Axios on iOS WKWebView to re-encode the Blob body, corrupting the
    // stream → AxiosError: Network Error (confirmed in device logs, Image 3).
    //
    // Fix: detect the actual MIME type from the Blob/File and send it as
    // Content-Type. This is correct for S3 pre-signed PUTs on all platforms.
    // For Android and Web this is also more correct than multipart/form-data,
    // but those platforms tolerated the wrong header — iOS does not.
    //
    // Additionally, on iOS WKWebView, Axios cannot stream a Blob body reliably
    // for large files (>3 MB). Converting the Blob to an ArrayBuffer first and
    // passing that to Axios ensures the full body is in memory before the PUT
    // starts, which WKWebView's NSURLSession handles correctly.
    const isIOSCordova =
      typeof window !== 'undefined' &&
      window.cordova &&
      window.device?.platform?.toLowerCase() === 'ios';

    const ionContentType = file.type || 'application/octet-stream';
    const contentType = isIOSCordova ? ionContentType : 'multipart/form-data';

    let body = file;

    if (isIOSCordova) {
      // Convert Blob to ArrayBuffer for reliable body delivery on WKWebView.
      // The Blob is already in-memory (created from __iosArrayBuffer in
      // fileInputHandler), so this slice-to-ArrayBuffer is a fast memcopy,
      // not a disk/URL read. No security-scope concern here.
      body = await file.arrayBuffer();
    }
    console.log('contentType', contentType);
    console.log('Content-MD5', fileMd5Base64);

    response = await axios.put(preSignedUrl, body, {
      headers: {
        appid: 'sales',
        'Content-Type': contentType,
        'Content-MD5': fileMd5Base64,
      },
      // Required for ArrayBuffer body on iOS — Axios must not try to
      // transform the request body (it defaults to JSON.stringify for objects).

      ...(isIOSCordova ? { transformRequest: [(data) => data] } : {}),
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setStatementUploadProgress((prev) =>
          commonDocUpload ? { ...prev, [fileType]: percentCompleted } : percentCompleted
        );
        if (percentCompleted === 100) {
          setStatementLinearProgress((prev) =>
            commonDocUpload ? { ...prev, [fileType]: true } : true
          );
        }
      },
    });
  } catch (e) {
    return response;
  }

  return response;
};

const handleCancelUpload = (typeName, context, cancelData) => {
  if (typeName === 'act') {
    context.setCancelActupload(cancelData);
  }
  if (typeName === 'atm') {
    context.setCancelAtmupload(cancelData);
  }
  if (typeName === 'businessOwnerAddress') {
    context.setCancelBOAupload(cancelData);
  }
};
export const uploadDocChecklist = async (...args) => {
  const fileFormat = args[0];
  const fileName = args[1];
  const fileType = args[2];
  const formData = args[3];
  const accessToken = args[4];
  const typeName = args[5];
  const setProgress = args[6];
  const context = args[7];
  const initiateUiResponse = args[8];
  let response = null;
  const source = axios.CancelToken.source();
  const cancelToken = source.token;
  const cancelData = {
    source,
    typeName,
  };
  if (typeName === 'deedOfTrust') {
    context.setCancelDeed(cancelData);
  }
  if (typeName === 'articleIncorp') {
    context.setCancelArtIncorp(cancelData);
  }
  if (typeName === 'certIncorp') {
    context.setCancelCertIncorp(cancelData);
  }
  if (typeName === 'regCertificate') {
    context.setCancelRegCer(cancelData);
  }
  if (typeName === 'corpResolution') {
    context.setCancelCorpRes(cancelData);
  }
  if (typeName === 'listOfOfficers') {
    context.setCancelListOff(cancelData);
  }
  if (typeName === 'dbaResolution') {
    context.setCancelDbaRes(cancelData);
  }
  if (typeName === 'LlcResolution') {
    context.setCancelLlcRes(cancelData);
  }
  if (typeName === 'opAgreement') {
    context.setCancelOpAgree(cancelData);
  }
  if (typeName === 'certOfOrg') {
    context.setCancelCertOrg(cancelData);
  }
  if (typeName === 'certOfTrustReg') {
    context.setCancelTrustReg(cancelData);
  }
  if (typeName === 'businessAddress') {
    context.setCancelBAupload(cancelData);
  }
  if (typeName === 'certOfIncumbency') {
    context.setCancelIncumbency(cancelData);
  }
  if (typeName === 'act22') {
    context.setCancelAct22upload(cancelData);
  }
  handleCancelUpload(typeName, context, cancelData);
  try {
    response = await axios.post(
      `${initiateUiResponse.REACT_APP_DOCUMENT_UPLOAD_URL}?format=${fileFormat}&name=${fileName}&type=${fileType}`,
      formData,
      {
        cancelToken,
        headers: {
          appid: 'sales',
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
        onUploadProgress: (ProgressEvent) => {
          const percentageCompleted = Math.round(
            (ProgressEvent.loaded * 100) / ProgressEvent.total
          );
          // controller.abort()
          setProgress((prevState) =>
            Object.assign({}, prevState, { [typeName]: percentageCompleted })
          );
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};
export const uploadDocXLDocCheckilst = async (...args) => {
  const fileFormat = args[0];
  const fileName = args[1];
  const fileType = args[2];
  const fileSize = args[3];
  const fileMd5Base64 = args[4];
  const accessToken = args[5];
  const typeName = args[6];
  const setProgress = args[7];
  const context = args[8];
  const initiateUiResponse = args[9];
  let response = null;
  const requestBody = {
    format: fileFormat,
    name: fileName,
    type: fileType,
    size: fileSize,
    contentMD5: fileMd5Base64,
  };
  const source = axios.CancelToken.source();
  const cancelToken = source.token;
  const cancelData = {
    source,
    typeName,
  };

  if (typeName === 'deedOfTrust') {
    context.setCancelDeed(cancelData);
  }
  if (typeName === 'corpResolution') {
    context.setCancelCorpRes(cancelData);
  }
  if (typeName === 'certIncorp') {
    context.setCancelCertIncorp(cancelData);
  }
  if (typeName === 'articleIncorp') {
    context.setCancelArtIncorp(cancelData);
  }
  if (typeName === 'listOfOfficers') {
    context.setCancelListOff(cancelData);
  }
  if (typeName === 'regCertificate') {
    context.setCancelRegCer(cancelData);
  }
  if (typeName === 'dbaResolution') {
    context.setCancelDbaRes(cancelData);
  }
  if (typeName === 'LlcResolution') {
    context.setCancelLlcRes(cancelData);
  }
  if (typeName === 'certOfOrg') {
    context.setCancelCertOrg(cancelData);
  }
  if (typeName === 'opAgreement') {
    context.setCancelOpAgree(cancelData);
  }
  if (typeName === 'certOfTrustReg') {
    context.setCancelTrustReg(cancelData);
  }
  if (typeName === 'certOfIncumbency') {
    context.setCancelIncumbency(cancelData);
  }
  if (typeName === 'businessAddress') {
    context.setCancelBAupload(cancelData);
  }
  if (typeName === 'act22') {
    context.setCancelAct22upload(cancelData);
  }
  handleCancelUpload(typeName, context, cancelData);
  try {
    response = await axios.post(
      `${initiateUiResponse.REACT_APP_DOCUMENT_UPLOAD_XL_URL}`,
      requestBody,
      {
        cancelToken,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
        },
        onUploadProgress: (progEvent) => {
          const percentageCompleted = Math.round((progEvent.loaded * 100) / progEvent.total);
          setProgress((prev) => Object.assign({}, prev, { [typeName]: percentageCompleted }));
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};

export const saveDocChecklist = async (docIds, context, flagCheck) => {
  const {
    accessToken,
    language,
    location,
    businessContactInformation,
    applicationId,
    applicantId,
    initiateUiResponse,
  } = context;
  const formData = {
    Event: 'CaptureDocumentChecklist',
    Application: {
      ApplicationID: applicationId || null,
      ApplicantID: applicantId || null,
      TemplateVersion: '2021-11-24',
      Source: {
        Language: language,
        Location: location === 'VI' ? 'VI' : 'PR',
        UtmSource: null,
        UtmMedium: null,
        UtmCampaign: null,
        UtmContent: null,
        UtmTerm: null,
        BranchCode: null,
      },
      Business: {
        DocReUploadFlag: flagCheck,
        Type: businessContactInformation.businessType,
        ...(returnBusinessDocs(businessContactInformation.businessType, docIds).length > 0
          ? {
              BusinessDocuments: returnBusinessDocs(
                businessContactInformation.businessType,
                docIds
              ),
            }
          : {}),
      },
      Processing: {
        CaseReference: [],
      },
    },
  };
  let result = null;
  try {
    result = await axios.post(initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json; charset=UTF-8',
      },
    });
  } catch (error) {
    return error.response;
  }
  return result;
};

const typeDBACheck = (selectedType, docIds) => {
  if (selectedType === 'DBA') {
    return [
      ...(docIds.dbaResolution
        ? [
            {
              DocType: 'DBA Resolution',
              DocId: docIds.dbaResolution,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};
const typeCorporationPartnership = (selectedType, docIds) => {
  if (
    selectedType === 'Corporation' ||
    selectedType === 'Corporation DBA' ||
    selectedType === 'Partnership'
  ) {
    return [
      ...(docIds.corpResolution
        ? [
            {
              DocType: 'Corporate Resolution',
              DocId: docIds.corpResolution,
            },
          ]
        : []),
      ...(docIds.certIncorp
        ? [
            {
              DocType: 'Certificate of Incorporation',
              DocId: docIds.certIncorp,
            },
          ]
        : []),
      ...(docIds.articleIncorp
        ? [
            {
              DocType: 'Articles of Incorporation',
              DocId: docIds.articleIncorp,
            },
          ]
        : []),
      ...(docIds.listOfOfficers
        ? [
            {
              DocType: 'List of Directors and Officers',
              DocId: docIds.listOfOfficers,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};
const typeLLCCheck = (selectedType, docIds) => {
  if (selectedType === 'LLC') {
    return [
      ...(docIds.LlcResolution
        ? [
            {
              DocType: 'LLC Resolution',
              DocId: docIds.LlcResolution,
            },
          ]
        : []),
      ...(docIds.certOfOrg
        ? [
            {
              DocType: 'Certificate of Organization',
              DocId: docIds.certOfOrg,
            },
          ]
        : []),
      ...(docIds.opAgreement
        ? [
            {
              DocType: 'Operational Agreement',
              DocId: docIds.opAgreement,
            },
          ]
        : []),
      ...(docIds.listOfOfficers
        ? [
            {
              DocType: 'List of Directors and Officers',
              DocId: docIds.listOfOfficers,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};
const typeTrustCheck = (selectedType, docIds) => {
  if (selectedType === 'Trust') {
    return [
      ...(docIds.deedOfTrust
        ? [
            {
              DocType: 'Deed of Trust',
              DocId: docIds.deedOfTrust,
            },
          ]
        : []),
      ...(docIds.certOfTrustReg
        ? [
            {
              DocType: 'Certification for Trust Registry',
              DocId: docIds.certOfTrustReg,
            },
          ]
        : []),
      ...(docIds.certOfIncumbency
        ? [
            {
              DocType: 'Certificate of Incumbency',
              DocId: docIds.certOfIncumbency,
            },
          ]
        : []),
      ...(docIds.regCertificate
        ? [
            {
              DocType: 'Commercial Registration Certificate',
              DocId: docIds.regCertificate,
            },
          ]
        : []),
    ];
  }
};

const returnBusinessDocs = (selectedType, docIds) => {
  if (selectedType === 'DBA') {
    return typeDBACheck(selectedType, docIds);
  }
  if (
    selectedType === 'Corporation' ||
    selectedType === 'Corporation DBA' ||
    selectedType === 'Partnership'
  ) {
    return typeCorporationPartnership(selectedType, docIds);
  }
  if (selectedType === 'LLC') {
    return typeLLCCheck(selectedType, docIds);
  }
  if (selectedType === 'Trust') {
    return typeTrustCheck(selectedType, docIds);
  }
};

export const uploadLaterDocument = async (appId, accessToken, initiateUiResponse) => {
  let response = null;
  try {
    response = await axios.post(
      initiateUiResponse.REACT_APP_LINK_INITIAL_CALL,
      { applicationId: appId, docReUpload: 'true' },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
        },
      }
    );
  } catch (e) {
    return response;
  }
  return response;
};

export const saveDocChecklistUploadLater = async (
  docIds,
  context,
  docBusinessType,
  reUploadFlag,
  productName,
  initiateUiResponse
) => {
  const { accessToken, language, location, urlAppId, parentUploadData, grandParentUploadData } =
    context;
  const currentUrl = window.location.href;
  let formData;

  if (currentUrl.includes('retail-form')) {
    formData = {
      Event: 'CaptureCaeDocuments',
      Application: {
        ApplicationID: urlAppId || null,
        TemplateVersion: '2021-08-05',
        Source: {
          Language: language,
          Location: 'PR',
          UtmSource: null,
          UtmMedium: null,
          UtmCampaign: null,
          UtmContent: null,
          UtmTerm: null,
          BranchCode: null,
        },
        Products: [
          {
            ProductType: 'IRA',
            ProductName: productName,
          },
        ],
        Beneficiaries: [
          {
            Documents: [
              ...(parentUploadData?.parent
                ? [{ DocType: 'CAE Form', DocId: parentUploadData.parent }]
                : []),
              ...(grandParentUploadData?.grandParent
                ? [
                    {
                      DocType: 'Proof of guardianship',
                      DocId: grandParentUploadData.grandParent,
                    },
                  ]
                : []),
            ],
          },
        ],
        Processing: {
          CaseReference: [],
        },
      },
    };
  } else {
    formData = {
      Event: 'CaptureDocumentReUpload',
      Application: {
        ApplicationID: urlAppId || null,
        TemplateVersion: '2021-11-24',
        Source: {
          Language: language,
          Location: location === 'VI' ? 'VI' : 'PR',
          UtmSource: null,
          UtmMedium: null,
          UtmCampaign: null,
          UtmContent: null,
          UtmTerm: null,
          BranchCode: null,
        },
        Business: {
          Type: docBusinessType,
          DocReUploadFlag: reUploadFlag,
          ...(returnBusinessDocs(docBusinessType, docIds).length > 0
            ? { BusinessDocuments: returnBusinessDocs(docBusinessType, docIds) }
            : {}),
        },
        Processing: {
          CaseReference: [],
        },
      },
    };
  }

  try {
    const result = await axios.post(
      initiateUiResponse.REACT_APP_SAVE_SUBMIT_APPLICATION_URL,
      formData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          appid: SALES,
          'Content-Type': 'application/json; charset=UTF-8',
        },
      }
    );
    return result;
  } catch (error) {
    return error.response;
  }
};

// works for google drive upload in cordova devices
export const wcgenerateFileMD5 = (blob) =>
  new Promise((resolve, reject) => {
    console.log('wcgenerateFileMD5');
    const platform = getRuntimePlatform();

    if (!(blob instanceof Blob)) {
      const error = `[MD5] Input is not a Blob on ${platform}`;
      console.error(error, blob);
      reject(new Error(error));
      return;
    }

    const reader = new FileReader();

    reader.onerror = () => {
      console.error(`[MD5] FileReader error on ${platform}`, reader.error);
      reject(reader.error);
    };

    reader.onload = () => {
      try {
        const buffer = reader.result;
        const wordArray = CryptoJS.lib.WordArray.create(buffer);
        const md5 = CryptoJS.MD5(wordArray).toString();
        resolve(md5);
      } catch (err) {
        console.error(`[MD5] Hashing failed on ${platform}`, err);
        reject(err);
      }
    };

    reader.readAsArrayBuffer(blob);
  });

export const generateFileMD5 = (file) =>
  new Promise((resolve, reject) => {
    console.log('generateFileMD5');
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
    const chunkSize = 2097152;
    const chunks = Math.ceil(file.size / chunkSize);

    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      spark.append(e.target.result);
      currentChunk += 1;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        const hash = spark.end();
        resolve(hash);
      }
    };

    fileReader.onerror = () => {
      reject();
    };
    function loadNext() {
      const start = currentChunk * chunkSize;
      const end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });

export const generateFileMD5Cordova = async (blob) => {
  try {
    return await wcgenerateFileMD5(blob);
  } catch (err) {
    if (isCordovaFn()) {
      console.warn('[MD5] Skipping MD5 on Cordova due to failure', err);
      return null;
    }
    throw err;
  }
};

/**
 * iOS Cordova-safe pre-signed URL uploader.
 *
 * Drop-in replacement for uploadDocumentByPreSignedURL on iOS Cordova.
 * cordova-plugin-advanced-http intercepts Axios and rejects Blob/ArrayBuffer
 * as the PUT body with: "data option supports only following data types: Object"
 *
 * XMLHttpRequest is NOT intercepted by advanced-http on WKWebView, so Blob
 * upload works natively — identical signature to uploadDocumentByPreSignedURL.
 *
 * @param {string}   preSignedUrl          - S3 pre-signed PUT URL
 * @param {Blob}     file                  - stableBlob (already materialized)
 * @param {string}   fileMd5Base64         - base64-encoded MD5 of the file
 * @param {Function} setProgress           - setStatementUploadProgress | setTaxUploadProgress
 * @param {Function} setLinearProgress     - setStatementLinearProgress  | setTaxLinearProgress
 * @param {string}   [fileType]            - used only when commonDocUpload=true
 * @param {Object}   [options]             - { commonDocUpload: bool }
 */
export const uploadToPreSignedURLviaXHR = async (
  preSignedUrl,
  file,
  fileMd5Base64,
  setProgress,
  setLinearProgress,
  fileType = null,
  options = {}
) => {
  const { commonDocUpload = false } = options;
  const xhrIsNative = XMLHttpRequest.prototype.send.toString().includes('[native code]');
  console.log('XHR send is native?', xhrIsNative);
  const getHttpPlugin = () => window.cordova?.plugins?.http || window.cordova?.plugin?.http || null;
  const http = getHttpPlugin();
  console.log('[UPLOAD INIT]', {
    fileType,
    size: file?.size,
    mime: file?.type,
  });
  console.log('[DECISION]', {
    pluginExists: !!http,
    isSentRequestFunction: typeof http?.sendRequest === 'function',
    getDataSerializer: http?.getDataSerializer?.(),
  });
  console.log('isSentRequestFunction', {
    isSentRequestFunction: typeof http?.sendRequest === 'function',
  });
  console.log('getDataSerializer', {
    getDataSerializer: http?.getDataSerializer?.(),
  });

  console.log('http', http);
  console.log('[XHR PATH] using native XHR fallback');

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', preSignedUrl, true);

    // Must match the headers used when the pre-signed URL was generated
    xhr.setRequestHeader('appid', 'sales');
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
    xhr.setRequestHeader('Content-MD5', fileMd5Base64);
    xhr.timeout = 3 * 60 * 1000;

    xhr.upload.onprogress = (progressEvent) => {
      if (!progressEvent.lengthComputable) return;
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      setProgress((prev) =>
        commonDocUpload ? { ...prev, [fileType]: percentCompleted } : percentCompleted
      );
      if (percentCompleted === 100) {
        setLinearProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: true } : true));
      }
    };

    xhr.onload = () => {
      // S3 pre-signed PUT returns HTTP 200 on success — same as Axios path
      if (xhr.status === 200 || xhr.status === 201 || xhr.status === 204) {
        // Return shape matches what Axios returns so callers need no changes
        resolve({ status: xhr.status, data: xhr.responseText });
      } else {
        console.error(`[XHR PreSignedUpload] Failed: HTTP ${xhr.status}`, xhr.responseText);
        setProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: 0 } : 0));
        setLinearProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: false } : false));
        resolve({ status: xhr.status, data: xhr.responseText }); // resolve so caller handles FAILED
      }
    };

    xhr.onerror = () => {
      console.error('[XHR PreSignedUpload] Network error');
      setProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: 0 } : 0));
      setLinearProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: false } : false));
      reject(new Error('XHR pre-signed upload network error'));
    };

    xhr.ontimeout = () => {
      console.error('[XHR PreSignedUpload] Timed out');
      setProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: 0 } : 0));
      setLinearProgress((prev) => (commonDocUpload ? { ...prev, [fileType]: false } : false));
      reject(new Error('XHR pre-signed upload timed out'));
    };

    // Send the raw Blob — WKWebView XHR handles this natively
    xhr.send(file);
  });
};
